import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const PatientSatisfaction = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button
          variant="ghost"
          className="mb-8"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
        
        <h1 className="text-4xl font-bold mb-6">Patient Satisfaction Impact</h1>
        <p className="text-lg text-gray-600 mb-8">
          Through personalized care and regular engagement, we've achieved a 25-30% increase in patient satisfaction scores, demonstrating the positive impact of our approach.
        </p>
        
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold">Key Improvements</h2>
          <ul className="list-disc list-inside space-y-4 text-gray-600">
            <li>Enhanced patient engagement and communication</li>
            <li>Personalized care plans and recommendations</li>
            <li>Improved access to healthcare resources</li>
            <li>Better understanding of treatment progress</li>
            <li>Increased confidence in care quality</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default PatientSatisfaction;